module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./ApplyDetailView.js"));
	}, "AfterSaleApplyDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleApplyDetailView!./src/pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/ApplyDetail/ApplyDetailView.js
// module id = 1976
// module chunks = 367